/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { Section } from 'spectacle-ppa';

import videoSlide from '../../baseSlides/videoSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_closing.md';
import markdownFileLevel2 from './level2_closing.md';
import markdownFileLevel3 from './level3_closing.md';
import markdownFileLevel4 from './level4_closing.md';
import markdownFileLevel5 from './level5_closing.md';
import markdownFileLevel6 from './level6_closing.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) },
  '2': { md: new MarkdownScript(markdownFileLevel2) },
  '3': { md: new MarkdownScript(markdownFileLevel3) },
  '4': { md: new MarkdownScript(markdownFileLevel4) },
  '5': { md: new MarkdownScript(markdownFileLevel5) },
  '6': { md: new MarkdownScript(markdownFileLevel6) }
};

function esClosingStory ({ level, regionData }) {
  const md = levels[level].md;
  return (
    <Section id="closing">

      {/* Intro to Es Closing in Levels 1 + 2 */}
      { (level === 2 || level === 6) &&
        videoSlide({
          id: 'intro-video',
          notes: md.getSubSectionAsHtml('Ian and Sara Intro', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Ian and Sara Intro', 'YouTube', regionData)
        })
      }

      {/* Framing Story Closing */}
      {videoSlide({
        id: 'story',
        notes: md.getSubSectionAsHtml('Esmeralda and Goober Closing Story', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Esmeralda and Goober Closing Story', 'YouTube', regionData)
      })}

    </Section>
  );
}

export default esClosingStory;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/60_esClosingStory/esClosingStorySection.jsx